module.exports = __webpack_public_path__ + "files/9a465b5b47ae6439194ab1b3cf563dff.png";